import dynamic from "next/dynamic";

export const CommonLabelInput = dynamic(() => import("./CommonLabelInput"), {
  ssr: false
});
